const fetcher = async (url) => {
  return fetch(url).then((r) => r.json());
};

export default fetcher;
